import Vue from 'vue';
import { socketStream } from '../../model/socket-stream.js';
import { accountEvents } from '../../model/accountevents.js';

export default {
	namespaced: true,
	state: {
		positions: {}
	},
	mutations: {
		replaceAllItems(state, data) {
			Vue.set(state, 'positions', data);
		}
	},
	getters: {
		getPositionsBySymbol(state) {
			return (symbol) => {
				if (!symbol) 
					return state.positions;
				return state.positions[symbol];
			}
		},
		getAllPositions(state) {
			return state.positions;
		},
	    // filters: like "['symbol', 'timeEnter', ...]"
	    positionsFlatFiltered(state) {
	    	return (filters) => {
	    		let positions = state.positions;
				let allItems = [];
				for (let key in positions)
					for (let i = 0; i < positions[key].length; i++)
						allItems.push(positions[key][i]);
	    		
	    		allItems.sort((a, b) => {
	    			for (let i = 0; i < filters.length; i++) {
	    				let aVal = a[filters[i].field];
                        let bVal = b[filters[i].field];                        
	    				let dir = filters[i].dir ? (filters[i].dir[0] === 'd' ? -1 : 1) : 1;
	    				if (aVal > bVal) return dir;
	    				if (aVal < bVal) return -dir;
	    			}
	    			return 0;
                });
	    		return allItems;
	    	};
	    }
	},
	actions: {
		initialize(state) {
			let subMsg = JSON.stringify({
				ClassName: "OpenPositionsSubscription"
			});
			socketStream.addChannelHandler('Positions', 'positions', (data) => {
				//if (stat[0] == 'update')
                let positions = parsePositionsArray(data[1]);
				updateAllPositions(state, positions);
				accountEvents.updateOpenPositions(positions);
			})
			socketStream.subscribeOnConnect(() => {
				socketStream.socket.send(subMsg);
			});
		}
	}
}

function updateAllPositions(state, items) {
	var posBySymbol = {};
	for (let i = 0; i < items.length; i++) {
		let pos = items[i];
		if (!posBySymbol[pos.symbol])
			posBySymbol[pos.symbol] = [ pos ];
		else
			posBySymbol[pos.symbol].push(pos);
	}
	state.commit('replaceAllItems', posBySymbol);
}

function parsePositionsArray(arrayOfArrays) {
	// [{id},\"{symbol}\",{side},{volume},{priceEnter},{curPrice},{resultDepo},{resultPoint},\"{timeEnter:yyyy.MM.ddTHH:mm:ss}\",{sl},{tp}]
	let positions = [];
	for (let i = 0; i < arrayOfArrays.length; i++) {
		let ar = arrayOfArrays[i];
	  	let pos = {
			id: ar[0],
			symbol: ar[1],
			side: ar[2],
			volume: ar[3],
			priceEnter: ar[4],
			curPrice: ar[5],
			resultDepo: ar[6],
			resultPoint: ar[7],
			timeEnter: ar[8],
			sl: ar[9],
			tp: ar[10]
	  	};
	  	// uncomment to test account events
	  	//if (i == 2) pos.id = Math.round(Math.random() * 10000);
	  	positions.push(pos);
	}
	return positions;
  }